import React from 'react'

import '@src/css/components/Main.css'

const Main = ({}) => {
    document.title = 'CLOUD'

    return (
        <div className={'main'}>
            <div>{''}</div>
        </div>
    )
}

export default Main
